export const METAMASK_GAS_LIMIT_ASSOCIATE = 800_000;
export const METAMASK_GAS_LIMIT_TRANSFER_FT = 50_000;
export const METAMASK_GAS_LIMIT_TRANSFER_NFT = 100_000;
export const _NATIVE_COIN_DECIMALS = 8;
export const HBAR_EVM_ADDRESS = "0x0000000000000000000000000000000000003ad2";
export const FEE_FACTOR = 10_000.0;
